export class FreeReducedMealAppCompletedPage {
    ID: number;
    AppID: number;
    PageID: number;
    ChildID = 0;
    AdultID = 0;
}